import { useForgotPassword as useForgotPasswordAPI } from "@tandemdiabetes/sugarmate-api-react-client"
import { useMemo } from "react"
import { noticeError } from "src/utils"

export function useForgotPassword() {
  const forgotPassword = useForgotPasswordAPI()

  // this wraps the forgotPassword with a try catch and logs the error
  return useMemo(
    () => !forgotPassword
      ? undefined
      : async (email: string, token: string) => {
        try {
          const response = await forgotPassword({
            email,
            token,
          })

          return response
        } catch (e) {
          noticeError(
            e,
            "ForgotPasswordEmail",
            { email },
          )

          throw e
        }
      },
    [forgotPassword],
  )
}
